<template>
  <div>
    <deployConfirm ref="deployConfirm" v-on:callback="startDeploy"></deployConfirm>
    <deployModal ref="deployModal" v-on:callback="getStackDeployTasks"></deployModal>
    <Card shadow class="content">
      <div class="main">
        <Row :gutter="24">
          <Col :md="24" :lg="12">
            <div style="margin-bottom: 15px">
              <Row class="title">
                <h4 :style="{float: 'left'}">堆栈详情</h4>
                <a v-on:click="getData()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
                <div :style="{float: 'right'}" style="padding-right: 10px">
                  <Button type="primary" @click="deploy" style="margin-right: 10px" size="small">部署</Button>
                  <Button type="warning" @click="$router.push({ name: 'container_stack_edit', params: {id: $route.params.id} })" style="margin-right: 10px" size="small">编辑</Button>
                  <Button @click="$router.push({ name: 'container_stack' })" size="small">返回</Button>
                </div>
              </Row>
              <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
              <div class="info-property" v-else>
                <dl>
                  <dt>堆栈名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>全局环境变量</dt>
                  <dd>
                    <p v-for="(envItem, envItemIndex) in info.environments" :key="`envItemIndex_${envItemIndex}`">{{ envItem.envName }}={{ envItem.envValue }}</p>
                  </dd>
                </dl>
                <dl>
                  <dt>创建用户</dt><dd v-if="info.created_user">{{ info.created_user.name ? info.created_user.name : info.created_user.username }}</dd>
                </dl>
                <dl>
                  <dt>创建时间</dt><dd>{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl>
                  <dt>最后修改用户</dt><dd v-if="info.updated_user">{{ info.updated_user.name ? info.updated_user.name : info.updated_user.username }}</dd>
                </dl>
                <dl>
                  <dt>最后修改时间</dt><dd>{{ moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
              </div>
            </div>
            <div style="margin-bottom: 15px">
              <Row class="title">
                <h4 :style="{float: 'left'}">部署记录</h4>
                <a v-on:click="getStackDeployTasks()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
              </Row>
              <Row>
                <Alert v-if="deployHistory.error" type="warning" show-icon>获取部署记录数据失败</Alert>
                <Table
                  v-else
                  border
                  size="small"
                  :height="0"
                  :loading="deployHistory.loading"
                  ref="table"
                  :data="deployHistory.data"
                  :columns="deployHistory.columns">
                </Table>
                <div style="margin: 10px 0; overflow: hidden;">
                  <div style="float: right;">
                    <page
                      :total="deployHistory.count"
                      :current="deployHistory.page"
                      :page-size="deployHistory.size"
                      @on-change="getStackDeployTasks"></page>
                  </div>
                </div>
              </Row>
            </div>
          </Col>
          <Col :md="24" :lg="12">
            <Row class="title">
              <h4 :style="{float: 'left'}">部署容器</h4>
              <div style="float: right;" v-if="info.deploy_type === 'template'">
                <i-switch v-model="configsDetailShow" size="large">
                  <span slot="open">详细</span>
                  <span slot="close">折叠</span>
                </i-switch>
              </div>
            </Row>
            <div v-if="info.deploy_type === 'yaml'">
              <codemirror ref="myCm" v-model="info.yaml" :options="cmOption" class="stack-detail-yaml"></codemirror>
            </div>
            <div v-else>
              <Card style="margin-bottom: 10px" v-for="(config, index) in info.configs" :key="index">
                <div slot="title" style="height: 14px">
                  <div style="float: left; height: 14px">
                    <Icon type="iconfont icon-docker" style="font-family: iconfont" size="12" color="#25B8EB" />
                    <b> 容器{{ index + 1 }} </b>
                    <Tag v-if="config.template">{{ config.template.title }}</Tag>
                  </div>
                </div>
                <div>
                  <div class="info-property" style="padding: 0; border: none; box-shadow: none">
                    <dl>
                      <dt>容器名</dt>
                      <dd>
                        <span v-if="config.containerName">{{ config.containerName }}</span>
                        <span v-else style="color: #999">自动生成</span>
                      </dd>
                    </dl>
                    <dl v-if="config.template && config.template.config">
                      <dt>镜像</dt><dd>{{ config.template.config.image }}</dd>
                    </dl>
                    <div v-if="configsDetailShow">
                      <dl>
                        <dt>部署节点</dt>
                        <dd>{{ config.node_name }}</dd>
                      </dl>
                      <dl>
                        <dt>完成后是否暂停</dt>
                        <dd>
                          <span v-if="config.is_suspend === true">是</span>
                          <span v-else-if="config.is_suspend === false">否</span>
                        </dd>
                      </dl>
                      <dl>
                        <dt>健康检测正常后继续</dt>
                        <dd>
                          <span v-if="config.is_health_check === true">是</span>
                          <span v-else-if="config.is_health_check === false">否</span>
                        </dd>
                      </dl>
                      <dl>
                        <dt>完成后延迟时间</dt><dd>{{ config.delay }} (秒)</dd>
                      </dl>
                      <dl>
                        <dt>配置变量</dt>
                        <dd>
                          <p v-for="(configVariableValue, configVariableKey, configVariableItemIndex) in config.configVariables" :key="`configVariableItemIndex_${configVariableItemIndex}`">
                            <span>{{ configVariableKey }}={{ configVariableValue }}</span>
                          </p>
                        </dd>
                      </dl>
                      <dl>
                        <dt>Hostname</dt><dd>{{ config.hostname }}</dd>
                      </dl>
                      <dl>
                        <dt>网络模式</dt><dd>{{ config.network_mode }}</dd>
                      </dl>
                      <dl>
                        <dt>环境变量</dt>
                        <dd>
                          <p v-for="(envValue, envKey, envItemIndex) in config.environments" :key="`envItemIndex_${envItemIndex}`">
                            <span>{{ envKey }}={{ envValue }}</span>
                          </p>
                        </dd>
                      </dl>
                      <dl>
                        <dt>目录映射</dt>
                        <dd>
                          <p v-for="(volumeItem, volumeItemIndex) in config.volumesData" :key="`volumeItemIndex_${volumeItemIndex}`">
                            <span>{{ volumeItem.hostPath }}:{{ volumeItem.bind }}:{{ volumeItem.mode }}</span>
                          </p>
                        </dd>
                      </dl>
                      <dl>
                        <dt>端口映射</dt>
                        <dd>
                          <p v-for="(portItem, portItemIndex) in config.portsData" :key="`portItemIndex_${portItemIndex}`">
                            <span>{{ portItem.host_address }}:{{ portItem.container_port }} -> {{ portItem.host_port }}/{{ portItem.protocol }}</span>
                          </p>
                        </dd>
                      </dl>
                      <div v-if="config.template && config.template.config">
                        <dl v-if="config.template.config.command">
                          <dt>Command</dt>
                          <dd>{{ config.template.config.command }}</dd>
                        </dl>
                        <dl v-if="config.template.config.domainname">
                          <dt>域</dt>
                          <dd>{{ config.template.config.domainname }}</dd>
                        </dl>
                        <dl v-if="config.template.config.restart_policy">
                          <dt>重启策略</dt>
                          <dd>
                            <span v-if="config.template.config.restart_policy.Name === 'on-failure'">失败时重启</span>
                            <span v-else-if="config.template.config.restart_policy.Name === 'always'">永远自动重启</span>
                            <span v-else>{{ config.template.config.restart_policy.Name }}</span>
                          </dd>
                        </dl>
                        <dl v-if="config.template.config.healthcheck">
                          <dt>健康检测</dt>
                          <dd>{{ config.template.config.healthcheck.test }}</dd>
                        </dl>
                        <dl v-if="config.template.config.healthcheck">
                          <dt>健康检测重试次数</dt>
                          <dd>{{ config.template.config.healthcheck.retries }}</dd>
                        </dl>
                        <dl v-if="config.template.config.entrypoint">
                          <dt>Entrypoint</dt>
                          <dd>{{ config.template.config.entrypoint }}</dd>
                        </dl>
                        <dl>
                          <dt>特权模式下运行</dt>
                          <dd>
                            <span v-if="config.template.config.privileged">允许</span>
                            <span v-else>不允许</span>
                          </dd>
                        </dl>
                        <dl>
                          <dt>分配伪终端 (tty)</dt>
                          <dd>
                            <span v-if="config.template.config.tty">是</span>
                            <span v-else>否</span>
                          </dd>
                        </dl>
                        <dl>
                          <dt>内核权限</dt>
                          <dd>
                            <span v-if="config.template.config.cap_add">{{ config.template.config.cap_add }}</span>
                            <span v-else>无</span>
                          </dd>
                        </dl>
                        <dl>
                          <dt>自动删除</dt>
                          <dd>
                            <span v-if="config.template.config.auto_remove">是</span>
                            <span v-else>否</span>
                          </dd>
                        </dl>
                        <dl v-if="config.template.config.nano_cpus">
                          <dt>限制Cpus</dt>
                          <dd>{{ config.template.config.nano_cpus }}</dd>
                        </dl>
                        <dl v-if="config.template.config.mem_limit">
                          <dt>限制Mems</dt>
                          <dd>{{ config.template.config.mem_limit }}</dd>
                        </dl>
                        <dl v-if="config.template.config.links">
                          <dt>容器链接</dt>
                          <dd>
                            <p v-for="(linkValue, linkKey, linkItemIndex) in config.template.config.dns" :key="`linkItemIndex_${linkItemIndex}`">{{ linkKey }}:{{ linkValue }}</p>
                          </dd>
                        </dl>
                        <dl v-if="config.template.config.dns">
                          <dt>容器DNS</dt>
                          <dd>
                            <p v-for="(dnsItem, dnsItemIndex) in config.template.config.dns" :key="`dnsItemIndex_${dnsItemIndex}`">{{ dnsItem }}</p>
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div v-else>
                      <dl>
                        <dt><Tooltip content="点击展开"><a v-on:click="configsDetailShow = true"><b>......</b></a></Tooltip></dt>
                        <dd></dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import deployConfirm from './components/deploy-confirm'
import deployModal from './components/deploy-modal'
import { detailContainerStack, getContainerStackDeployTasks } from '@/api/container/stack'
import { codemirror } from 'vue-codemirror-lite'
import 'codemirror/theme/monokai.css'
import 'codemirror/theme/lesser-dark.css'
import 'codemirror/theme/mbo.css'
import 'codemirror/mode/yaml/yaml.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/display/autorefresh'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/foldcode.js'

export default {
  name: 'detail',
  components: {
    deployConfirm,
    deployModal,
    codemirror
  },
  data () {
    return {
      infoError: false,
      info: {},
      moment: moment,
      configsDetailShow: false,
      deployHistory: {
        data: [],
        columns: [
          {
            title: '开始时间',
            key: 'created_at',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '结束时间',
            key: 'ended_at',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              if (params.row.ended_at) {
                return h('span', moment(params.row.ended_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '耗时(秒)',
            key: 'use_time',
            align: 'center',
            minWidth: 80
          },
          {
            title: '集群',
            key: 'cluster_name',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.cluster) {
                return h('a', {
                  on: {
                    click: () => {
                      this.$router.push({ name: 'container_cluster_detail', params: { id: params.row.cluster } })
                    }
                  }
                }, params.row.cluster_name)
              }
            }
          },
          {
            title: '部署用户',
            key: 'created_user',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              return h('span', params.row.created_user.name ? params.row.created_user.name : params.row.created_user.username)
            }
          },
          {
            title: '状态',
            key: 'status',
            minWidth: 100,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              let iconType = 'md-clock'
              let style = {
                color: '#2d8cf0'
              }
              if (params.row.status === 'finish') {
                iconType = 'md-checkmark'
                style.color = '#19be6b'
              } else if (params.row.status === 'paused') {
                iconType = 'ios-pause'
                style.color = '#ff9900'
              } else if (params.row.status === 'stop') {
                iconType = 'md-warning'
                style.color = '#ed4014'
              } else if (params.row.status === 'starting') {
                iconType = 'ios-loading'
                style.color = '#2d8cf0'
                style.animation = 'ani-demo-spin 1s linear infinite'
              }
              return h('div', [
                h('Icon', {
                  props: {
                    type: iconType,
                    size: 16
                  },
                  style: style
                }),
                h('span', {
                  style: {
                    color: style.color
                  }
                }, ' ' + params.row.status_verbose)
              ])
            }
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.deployModal.openModal(params.row.id, this.$route.params.id)
                    }
                  }
                }, '详情')
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        error: false,
        loading: false
      },
      // YAML
      cmOption: {
        mode: {
          name: 'yaml'
        },
        lineNumbers: false,
        matchBrackets: true,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'mbo',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        foldGutter: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        height: '600px',
        readOnly: true,
        showCursorWhenSelecting: true,
        // 在行槽中添加行号显示器、折叠器、语法检测器
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
        // 快捷键
        extraKeys: {
          'F11': function (cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'))
          },
          'Esc': function (cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false)
          }
        }
      }
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  methods: {
    init () {
      this.getData()
      this.getStackDeployTasks()
    },
    getData () {
      detailContainerStack(this.$route.params.id).then(res => {
        this.info = res.data
        this.infoError = false
      }).catch(res => {
        this.infoError = true
        console.log(res.response)
      })
    },
    getStackDeployTasks (value = 1) {
      this.deployHistory.page = value
      let params = {
        size: this.deployHistory.size,
        page: this.deployHistory.page,
        stack: this.$route.params.id
      }
      this.deployHistory.loading = true
      getContainerStackDeployTasks(params).then(res => {
        this.deployHistory.data = res.data.results
        this.deployHistory.count = res.data.count
        this.deployHistory.error = false
        this.deployHistory.loading = false
      }).catch(res => {
        this.deployHistory.data = []
        this.deployHistory.count = 0
        this.deployHistory.error = true
        this.deployHistory.loading = false
      })
    },
    deploy () {
      this.$refs.deployConfirm.deploy(this.$route.params.id)
    },
    startDeploy (stackId, taskId) {
      this.$refs.deployModal.openModal(taskId, stackId)
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .stack-detail-yaml {
    .CodeMirror {
      height: 500px;
      font-size: 14px;
    }
    .CodeMirror-fullscreen {
      z-index: 999 !important;
    }
    .CodeMirror-hints {
      z-index: 1000 !important;
    }
  }
</style>
